import { render, staticRenderFns } from "./IndividualRegisterIcm.vue?vue&type=template&id=0a6de1ae"
import script from "./IndividualRegisterIcm.vue?vue&type=script&lang=js"
export * from "./IndividualRegisterIcm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports